import { render, staticRenderFns } from "./ajxq.vue?vue&type=template&id=239ddd52&scoped=true&"
import script from "./ajxq.vue?vue&type=script&lang=js&"
export * from "./ajxq.vue?vue&type=script&lang=js&"
import style0 from "./ajxq.vue?vue&type=style&index=0&id=239ddd52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ddd52",
  null
  
)

export default component.exports